export default {"src":"/_next/static/media/0x218532a12a389a4a92fc0c5fb22901d1c19198aa.bc433701.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};